import type { CategoryMeta, NewsItem, Resource, Topic } from "@/types/content";

export const categories: CategoryMeta[] = [
  {
    key: "movie",
    label: "影视",
    path: "/category/movie",
    icon: "ri-film-line",
    title: "影视资源 - 无码高清资源平台",
    intro: "汇集科幻、悬疑、剧情、纪录等多元影视作品，按类型、地区、年份快速定位你想看的内容。",
    description: "无码影视资源分类，海量高清无码影视作品尽在掌握。",
    keywords: "无码影视,高清影视资源,影视资讯,电影,电视剧",
  },
  {
    key: "anime",
    label: "动漫",
    path: "/category/anime",
    icon: "ri-sword-line",
    title: "动漫资源 - 无码高清资源平台",
    intro: "日本新番、剧场版与国漫佳作集中收录，追踪季度更新与高分口碑作品。",
    description: "无码动漫资源分类，新番、剧场版与国漫高清作品集中浏览。",
    keywords: "无码动漫,动漫资源,新番,剧场版,国漫",
  },
  {
    key: "music",
    label: "音乐",
    path: "/category/music",
    icon: "ri-music-2-line",
    title: "音乐资源 - 无码高清资源平台",
    intro: "专辑、现场实录、原声带与单曲精选，从独立电子到城市流行一网打尽。",
    description: "无码音乐资源分类，专辑、现场实录与原声带高清资源汇总。",
    keywords: "无码音乐,音乐资源,专辑,原声带,现场实录",
  },
];

export const resources: Resource[] = [
  {
    id: "m-01",
    title: "深海回声",
    category: "movie",
    type: "电影",
    region: "中国",
    year: "2024",
    tags: ["科幻", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=Lone%20diver%20suspended%20in%20deep%20ocean%20light%20rays%2C%20bioluminescent%20particles%20drifting%20in%20dark%20water%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-01&orientation=portrait",
    summary: "深海科考队在海沟底部捕捉到一段无法解析的回声，队员们的记忆开始彼此错位。",
    description:
      "一支深海科考队在马里亚纳海沟执行例行勘探时，接收到一段规律得不像自然产生的回声信号。随着信号被反复回放，队员们开始回忆起从未发生过的经历，彼此的记忆逐渐交叉、覆盖。影片以冷峻的蓝黑色调构建压迫感，把科学理性与个人记忆的崩塌并置，最终把答案留在了海面之下。资源为 4K HDR 修复版本，画面颗粒与水下散射层次完整保留。",
    rating: 8.9,
    views: 128400,
    publishDate: "2024-09-12",
    duration: "128 分钟",
    quality: "4K HDR 高清",
  },
  {
    id: "m-02",
    title: "长夜微光",
    category: "movie",
    type: "电视剧",
    region: "中国",
    year: "2023",
    tags: ["剧情", "都市"],
    cover:
      "https://readdy.ai/api/search-image?query=Single%20lit%20window%20in%20a%20tall%20city%20tower%20at%20night%2C%20rain%20slicked%20streets%20below%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-02&orientation=portrait",
    summary: "一栋写字楼的夜班保洁、外卖骑手与值班编辑，三条人生在深夜的同一层楼交汇。",
    description:
      "故事发生在城市中心一栋写字楼的二十七层。夜班保洁员、跑夜单的外卖骑手和赶稿的值班编辑，在凌晨两点到清晨六点之间反复相遇。三组人物各自背负着不被看见的困境，却因为一台坏掉的饮水机和一盏总是熄灭的走廊灯慢慢产生联系。剧集以单元结构推进，36 集完整收录，1080P 高码率版本呈现夜戏暗部细节。",
    rating: 8.5,
    views: 96500,
    publishDate: "2023-11-03",
    duration: "全 36 集",
    quality: "1080P 高清",
  },
  {
    id: "m-03",
    title: "第七码头",
    category: "movie",
    type: "电影",
    region: "日本",
    year: "2022",
    tags: ["犯罪", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=Foggy%20harbor%20pier%20with%20stacked%20shipping%20containers%20and%20a%20single%20silhouette%20walking%20away%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-03&orientation=portrait",
    summary: "港口第七码头连续三晚出现无人认领的集装箱，里面装着同一间公寓的全部家具。",
    description:
      "港务调查员在第七码头发现三个无人申报的集装箱，里面整齐摆放着同一间公寓里被搬空的全部物品。随着调查深入，一件十年前的失踪案被重新翻出，码头工人的沉默与记录簿上的涂改形成微妙的对照。影片用大量固定机位和潮湿的雾气摄影构建冷感，节奏克制，线索埋得极深。",
    rating: 8.2,
    views: 74200,
    publishDate: "2022-06-18",
    duration: "116 分钟",
    quality: "1080P 高清",
  },
  {
    id: "m-04",
    title: "沙丘之外",
    category: "movie",
    type: "短片",
    region: "美国",
    year: "2024",
    tags: ["科幻"],
    cover:
      "https://readdy.ai/api/search-image?query=Vast%20desert%20dunes%20under%20a%20ringed%20planet%20sky%2C%20tiny%20traveler%20silhouette%20on%20a%20ridge%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-04&orientation=portrait",
    summary: "一名测绘员在沙漠尽头发现一块不属于任何地图的界碑，24 分钟的极简科幻小品。",
    description:
      "全片只有一名演员和一片沙丘。测绘员按坐标抵达任务终点，却发现那里立着一块刻着陌生文字的界碑，而 GPS 显示此处不应有任何人工物。短片用 24 分钟完成一次关于边界与未知的推演，音效设计极为出色，几乎不依赖对白。",
    rating: 7.9,
    views: 41200,
    publishDate: "2024-03-21",
    duration: "24 分钟",
    quality: "4K 高清",
  },
  {
    id: "m-05",
    title: "风起南岸",
    category: "movie",
    type: "电视剧",
    region: "中国",
    year: "2024",
    tags: ["年代", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Old%20southern%20river%20town%20rooftops%20in%20golden%20dusk%20haze%2C%20stone%20bridge%20and%20lanterns%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-05&orientation=portrait",
    summary: "八十年代南方小城，一条要拆的老街和三代人的去留选择，40 集年代群像。",
    description:
      "南岸老街要改建的消息传开后，靠修钟表为生的祖父、在码头做调度员的父亲和准备外出读书的女儿，各自盘算着不同的未来。剧集把镜头对准街巷日常，用大量生活细节还原八十年代南方小城的质感。40 集完整版，含片头片尾未删减段落。",
    rating: 8.6,
    views: 88700,
    publishDate: "2024-05-08",
    duration: "全 40 集",
    quality: "4K 高清",
  },
  {
    id: "m-06",
    title: "镜中列车",
    category: "movie",
    type: "电影",
    region: "韩国",
    year: "2023",
    tags: ["悬疑", "惊悚"],
    cover:
      "https://readdy.ai/api/search-image?query=Endless%20train%20corridor%20with%20mirrored%20walls%20and%20repeating%20cold%20ceiling%20lights%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-06&orientation=portrait",
    summary: "末班地铁的乘客发现，车窗里的倒影比车厢里的人多了两个。",
    description:
      "一列末班地铁在隧道中临时停车，乘客们发现车窗倒影里的人数对不上。随着列车一次次经过同一个站台，车厢内的人际关系被彻底打乱，每个人都被迫面对自己最想藏起来的那部分。影片以单一场景完成 122 分钟的叙事，镜面调度是最大看点。",
    rating: 8.1,
    views: 69300,
    publishDate: "2023-08-30",
    duration: "122 分钟",
    quality: "1080P 高清",
  },
  {
    id: "m-07",
    title: "午夜电台",
    category: "movie",
    type: "电影",
    region: "中国",
    year: "2021",
    tags: ["惊悚", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20radio%20microphone%20in%20a%20dark%20empty%20studio%2C%20dust%20in%20a%20single%20beam%20of%20light%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-07&orientation=portrait",
    summary: "一档停播十年的午夜节目突然复播，主持人收到的第一条热线来自十年前的自己。",
    description:
      "废弃电台旧址的调音台在无人操作的情况下重新亮起，一档停播十年的午夜节目开始准时播出。新上任的夜间值机员接起热线，电话那头的声音与自己完全一致。影片在狭小的直播间里完成大部分叙事，靠声音与光影制造持续的紧张感。",
    rating: 7.6,
    views: 55800,
    publishDate: "2021-10-15",
    duration: "104 分钟",
    quality: "1080P 高清",
  },
  {
    id: "m-08",
    title: "雪线之上",
    category: "movie",
    type: "纪录片",
    region: "中国",
    year: "2023",
    tags: ["纪录"],
    cover:
      "https://readdy.ai/api/search-image?query=Snow%20covered%20mountain%20ridge%20above%20clouds%2C%20climber%20rope%20line%20crossing%20the%20frame%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mv-08&orientation=portrait",
    summary: "六集纪录长片，跟拍高山气象观测站的完整一个雪季。",
    description:
      "摄制组在海拔四千二百米的气象观测站驻守一个完整雪季，记录三名观测员的日常工作与极端天气下的生活。片中大量航拍与延时素材展现了云层之上的光线变化，也如实呈现了长期高海拔驻守带来的身体与情绪消耗。六集完整收录。",
    rating: 9.1,
    views: 102300,
    publishDate: "2023-12-02",
    duration: "全 6 集",
    quality: "4K HDR 高清",
  },
  {
    id: "a-01",
    title: "星轨编年史",
    category: "anime",
    type: "TV动画",
    region: "日本",
    year: "2024",
    tags: ["科幻", "冒险"],
    cover:
      "https://readdy.ai/api/search-image?query=Young%20star%20cartographer%20standing%20on%20a%20floating%20rock%20island%20above%20a%20glowing%20nebula%20sea%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-01&orientation=portrait",
    summary: "星图绘制师少女带着一张空白海图出发，要找到被从所有星图上抹去的那颗星。",
    description:
      "在依靠星图航行的群岛世界，一名年轻的星图绘制师继承了师父留下的空白海图。她与擅长修理旧式导航仪的伙伴一起，沿着失真的星轨寻找一颗被刻意抹去的星体。作品以细腻的手绘质感呈现宇宙与海面交叠的奇观，24 集完整收录，含未播出特典。",
    rating: 9.2,
    views: 156800,
    publishDate: "2024-07-06",
    duration: "全 24 集",
    quality: "1080P 高清",
  },
  {
    id: "a-02",
    title: "夏末信号",
    category: "anime",
    type: "剧场版",
    region: "日本",
    year: "2023",
    tags: ["青春", "剧情"],
    cover:
      "https://readdy.ai/api/search-image?query=Two%20students%20on%20a%20seaside%20railway%20platform%20at%20sunset%2C%20summer%20wind%20and%20paper%20lanterns%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-02&orientation=portrait",
    summary: "海边小镇的最后一个夏天，两个少年用一台旧无线电向十年后发送信号。",
    description:
      "即将撤离的海边小镇只剩下不到二十户人家。两个少年在废弃的信号站里修好一台旧无线电，决定向十年后的同一频率发送录音。剧场版用一整部电影的篇幅讲述这个夏天最后的二十天，光影与配乐都极具夏日气息，108 分钟完整版。",
    rating: 8.8,
    views: 119400,
    publishDate: "2023-09-09",
    duration: "108 分钟",
    quality: "1080P 高清",
  },
  {
    id: "a-03",
    title: "墨色江湖",
    category: "anime",
    type: "国漫",
    region: "中国",
    year: "2024",
    tags: ["武侠", "奇幻"],
    cover:
      "https://readdy.ai/api/search-image?query=Ink%20wash%20swordsman%20on%20a%20bamboo%20cliff%20with%20drifting%20calligraphy%20strokes%20in%20the%20air%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-03&orientation=portrait",
    summary: "以水墨为武学根基的江湖，一个不会写字的少年却握住了最强的一笔。",
    description:
      "在这个江湖里，招式以墨迹显形，境界越高墨色越淡。出身抄书铺的少年无法识字，却能在挥剑时留下空白的一笔。他被卷入两大门派的墨卷之争，也第一次弄清自己身世的来处。国漫团队制作，26 集，水墨特效与打斗设计是最大亮点。",
    rating: 8.9,
    views: 134200,
    publishDate: "2024-04-12",
    duration: "全 26 集",
    quality: "4K 高清",
  },
  {
    id: "a-04",
    title: "机械花园",
    category: "anime",
    type: "TV动画",
    region: "日本",
    year: "2022",
    tags: ["科幻", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Overgrown%20mechanical%20garden%20with%20giant%20rusted%20gears%20and%20blooming%20white%20flowers%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-04&orientation=portrait",
    summary: "废弃工厂里的园艺机器人，用十二年时间种出了一整座花园。",
    description:
      "工厂停产之后，园区里只剩下一台负责绿化的旧型机器人。它按照过时的养护手册，一年一年地把荒地变成花园，也在过程中慢慢理解了「照顾」这件事。全片几乎没有冲突，靠季节变化与细小的机械动作推进，是极度安静的治愈系作品。",
    rating: 8.4,
    views: 90300,
    publishDate: "2022-10-04",
    duration: "全 12 集",
    quality: "1080P 高清",
  },
  {
    id: "a-05",
    title: "猫町物语",
    category: "anime",
    type: "TV动画",
    region: "日本",
    year: "2021",
    tags: ["治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20japanese%20alley%20cats%20sitting%20on%20stone%20steps%20under%20warm%20shop%20lanterns%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-05&orientation=portrait",
    summary: "老商店街的猫在夜里会开口说话，替店主们解决白天解决不了的小麻烦。",
    description:
      "一条即将改造的老商店街，白天生意冷清，夜里却热闹起来。街上的猫会挨家挨户串门，替店主们传递那些说不出口的话。13 集单元剧，每集讲一个店铺和一个人的故事，温柔又带一点笨拙的幽默。",
    rating: 8.7,
    views: 78400,
    publishDate: "2021-05-22",
    duration: "全 13 集",
    quality: "1080P 高清",
  },
  {
    id: "a-06",
    title: "烬海行者",
    category: "anime",
    type: "国漫",
    region: "中国",
    year: "2023",
    tags: ["奇幻", "冒险"],
    cover:
      "https://readdy.ai/api/search-image?query=Ash%20sea%20wanderer%20with%20a%20glowing%20lantern%20staff%20walking%20through%20black%20volcanic%20plains%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-06&orientation=portrait",
    summary: "灰烬覆盖的大陆上，提灯行者靠回收熄灭的火焰换取通行权。",
    description:
      "这个世界在百年前被一场大火烧过，只剩灰烬与零星残焰。提灯行者带着一盏能储存火焰的旧灯，在城镇之间穿行，用收集到的火种换取通行与食物。20 集的故事围绕他寻找最后一座仍在燃烧的城市展开，美术设定冷冽而有辨识度。",
    rating: 8.3,
    views: 87200,
    publishDate: "2023-02-17",
    duration: "全 20 集",
    quality: "1080P 高清",
  },
  {
    id: "a-07",
    title: "逆光列车",
    category: "anime",
    type: "剧场版",
    region: "日本",
    year: "2024",
    tags: ["剧情", "青春"],
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20night%20train%20interior%20with%20a%20girl%20looking%20out%2C%20city%20lights%20streaking%20past%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-07&orientation=portrait",
    summary: "每天同一班末班车，她都在等一个已经搬走的邻座。",
    description:
      "高中三年级的最后一个学期，少女每天都会搭同一班末班车回家。她习惯性地为邻座留着位置，即使那个人一年前就搬去了别的城市。剧场版在一趟四十分钟的车程里，用回忆与窗外光影拼出一个关于告别的故事，96 分钟，节奏极稳。",
    rating: 8.6,
    views: 66800,
    publishDate: "2024-08-23",
    duration: "96 分钟",
    quality: "1080P 高清",
  },
  {
    id: "a-08",
    title: "云端图书馆",
    category: "anime",
    type: "TV动画",
    region: "中国",
    year: "2022",
    tags: ["奇幻"],
    cover:
      "https://readdy.ai/api/search-image?query=Towering%20cloud%20library%20with%20floating%20books%20and%20a%20long%20spiral%20staircase%20of%20light%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-an-08&orientation=portrait",
    summary: "漂浮在云层之上的图书馆，收藏的是所有人忘掉的记忆。",
    description:
      "云层之上有一座会移动的图书馆，馆藏不是书，而是被人遗忘的记忆。新来的整理员要把散落的记忆重新归档，也因此不断遇见与自己有关的片段。16 集的奇幻单元剧，设定轻盈，世界观完整。",
    rating: 8.0,
    views: 52900,
    publishDate: "2022-03-11",
    duration: "全 16 集",
    quality: "1080P 高清",
  },
  {
    id: "mu-01",
    title: "潮汐频率",
    category: "music",
    type: "专辑",
    region: "中国",
    year: "2024",
    tags: ["电子", "独立"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20ocean%20waveform%20sculpture%20in%20dark%20space%2C%20glowing%20amber%20frequency%20lines%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-01&orientation=portrait",
    summary: "把潮汐数据转成波形的一张概念专辑，10 首曲目，42 分钟连续听感。",
    description:
      "创作者把一整年的潮汐观测数据转换成合成器参数，完成了这张以「频率」为核心的专辑。十首曲目之间没有明显间断，整体像一次完整的涨落过程。母带保留了大量低频细节，建议用耳机连续收听。",
    rating: 8.8,
    views: 76200,
    publishDate: "2024-06-14",
    duration: "10 首 · 42 分钟",
    quality: "无损高清音源",
  },
  {
    id: "mu-02",
    title: "城市夜行",
    category: "music",
    type: "专辑",
    region: "日本",
    year: "2023",
    tags: ["城市流行"],
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20reflections%20on%20a%20rainy%20city%20street%20at%20midnight%2C%20blurred%20taxi%20lights%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-02&orientation=portrait",
    summary: "十二首夜行曲，复古合成器与现场贝斯的组合，湿漉漉的城市感。",
    description:
      "专辑以午夜到清晨的时间线排列，前半张偏向舞曲节奏，后半张逐渐慢下来。制作上刻意保留了八十年代合成器的粗糙质感，同时加入现场贝斯与电钢琴，听感比传统城市流行更有湿度。12 首曲目完整收录。",
    rating: 9.0,
    views: 98400,
    publishDate: "2023-04-19",
    duration: "12 首 · 51 分钟",
    quality: "无损高清音源",
  },
  {
    id: "mu-03",
    title: "山与海之间",
    category: "music",
    type: "现场实录",
    region: "中国",
    year: "2024",
    tags: ["民谣"],
    cover:
      "https://readdy.ai/api/search-image?query=Acoustic%20guitar%20on%20a%20wooden%20stage%20beside%20mountains%20and%20sea%2C%20warm%20stage%20haze%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-03&orientation=portrait",
    summary: "海边山谷里的两小时现场实录，14 首曲目，几乎不加修饰的收音。",
    description:
      "这场演出在一个能同时看到山脊与海面的露天场地完成，全程只有一把木吉他、一支口琴和一台旧手风琴。录音保留了观众席的风声与远处的浪声，没有做过多的后期修饰。14 首曲目，68 分钟，适合在夜里安静地完整听一遍。",
    rating: 8.5,
    views: 61300,
    publishDate: "2024-02-26",
    duration: "14 首 · 68 分钟",
    quality: "现场高清音源",
  },
  {
    id: "mu-04",
    title: "霓虹序曲",
    category: "music",
    type: "专辑",
    region: "韩国",
    year: "2022",
    tags: ["电子"],
    cover:
      "https://readdy.ai/api/search-image?query=Glowing%20prism%20and%20glass%20tubes%20with%20pulsing%20light%2C%20abstract%20electronic%20visual%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-04&orientation=portrait",
    summary: "九首节拍实验，把人声切片当作打击乐来用。",
    description:
      "整张专辑的人声都被处理成极短的切片，与鼓组一起构成节奏骨架。九首曲目在结构上层层递进，最后两首几乎完全剥离旋律。制作干净利落，低频下潜和空间感都很出色。",
    rating: 8.1,
    views: 47700,
    publishDate: "2022-07-08",
    duration: "9 首 · 36 分钟",
    quality: "无损高清音源",
  },
  {
    id: "mu-05",
    title: "木质回声",
    category: "music",
    type: "专辑",
    region: "中国",
    year: "2023",
    tags: ["后摇"],
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20worn%20wood%20grain%20with%20sound%20ripples%2C%20soft%20amber%20backlight%20in%20darkness%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-05&orientation=portrait",
    summary: "八首长篇后摇，全部用木质空间录制，54 分钟的情绪爬坡。",
    description:
      "乐队把录音设备搬进一间全木结构的老厂房，利用空间本身的共鸣完成了这张专辑。八首曲目大多在七分钟以上，结构从极静慢慢堆叠到爆发，再回到安静。适合完整收听，不建议随机播放。",
    rating: 8.9,
    views: 83100,
    publishDate: "2023-10-27",
    duration: "8 首 · 54 分钟",
    quality: "无损高清音源",
  },
  {
    id: "mu-06",
    title: "银河留声机",
    category: "music",
    type: "专辑",
    region: "美国",
    year: "2024",
    tags: ["爵士"],
    cover:
      "https://readdy.ai/api/search-image?query=Vinyl%20record%20spinning%20under%20a%20starry%20projection%2C%20golden%20horn%20silhouette%20nearby%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-06&orientation=portrait",
    summary: "十一首爵士小品，钢琴、贝斯与一支长号的深夜对话。",
    description:
      "这张专辑在同一间录音室里连续录了三个夜晚，保留了大量的即兴段落与乐手之间的呼吸声。编制很小，钢琴、贝斯和长号构成主要声部，偶尔加入弱音小号。整体气质松弛，适合深夜播放。",
    rating: 8.4,
    views: 39500,
    publishDate: "2024-01-30",
    duration: "11 首 · 58 分钟",
    quality: "无损高清音源",
  },
  {
    id: "mu-07",
    title: "雨林笔记",
    category: "music",
    type: "原声带",
    region: "中国",
    year: "2023",
    tags: ["世界音乐"],
    cover:
      "https://readdy.ai/api/search-image?query=Rainforest%20canopy%20with%20mist%20and%20dappled%20amber%20sunbeams%2C%20handmade%20percussion%20in%20foreground%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-07&orientation=portrait",
    summary: "自然纪录片的原声带，16 段配乐加真实雨林环境采样。",
    description:
      "为一部雨林题材纪录片创作的原声带，旋律素材来自实地采集的鸟鸣与虫声。十六段配乐按纪录片的章节顺序排列，既可单独聆听，也能完整还原影像的叙事节奏。",
    rating: 8.6,
    views: 56600,
    publishDate: "2023-06-05",
    duration: "16 首 · 47 分钟",
    quality: "无损高清音源",
  },
  {
    id: "mu-08",
    title: "寂静电台",
    category: "music",
    type: "单曲",
    region: "中国",
    year: "2024",
    tags: ["氛围"],
    cover:
      "https://readdy.ai/api/search-image?query=Single%20glowing%20microphone%20in%20a%20silent%20empty%20room%2C%20soft%20amber%20haze%20and%20long%20shadows%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20minimal%20geometric%20composition%2C%20no%20text%2C%20cinematic%20lighting%2C%20premium%20editorial%20poster%20style%2C%20high%20detail&width=600&height=900&seq=wm-mu-08&orientation=portrait",
    summary: "六分钟的氛围单曲，几乎只有底噪、钢琴余音和一段模糊的人声。",
    description:
      "单曲以一段真实的调频底噪开场，随后加入极轻的钢琴单音与几乎听不清的人声片段。整首作品没有明确的高潮，更像一个被拉长的瞬间，适合作为工作或睡前的背景音。",
    rating: 7.8,
    views: 34200,
    publishDate: "2024-09-28",
    duration: "1 首 · 6 分钟",
    quality: "无损高清音源",
  },
];

export const newsItems: NewsItem[] = [
  { id: "n-01", title: "《深海回声》发布 4K HDR 修复版，水下摄影细节全面还原", date: "2024-10-16", resourceId: "m-01", category: "movie", kind: "资源更新" },
  { id: "n-02", title: "《星轨编年史》第 24 集收官，最终话分镜稿同步公开", date: "2024-10-15", resourceId: "a-01", category: "anime", kind: "新番进度" },
  { id: "n-03", title: "《潮汐频率》概念专辑上线，十首曲目连续听感完整保留", date: "2024-10-14", resourceId: "mu-01", category: "music", kind: "音乐上架" },
  { id: "n-04", title: "《墨色江湖》水墨打斗幕后：一集耗掉三千张原画", date: "2024-10-12", resourceId: "a-03", category: "anime", kind: "幕后资讯" },
  { id: "n-05", title: "《风起南岸》40 集完整版上线，含未删减片头段落", date: "2024-10-11", resourceId: "m-05", category: "movie", kind: "资源更新" },
  { id: "n-06", title: "《城市夜行》实体黑胶再版，母带重新处理", date: "2024-10-09", resourceId: "mu-02", category: "music", kind: "音乐上架" },
  { id: "n-07", title: "《逆光列车》剧场版新增 96 分钟完整音轨说明", date: "2024-10-07", resourceId: "a-07", category: "anime", kind: "版本说明" },
  { id: "n-08", title: "《雪线之上》获年度纪录长片推荐，六集全片重制", date: "2024-10-05", resourceId: "m-08", category: "movie", kind: "行业动态" },
  { id: "n-09", title: "《山与海之间》现场实录上线，保留山谷风声与海浪采样", date: "2024-10-03", resourceId: "mu-03", category: "music", kind: "音乐上架" },
  { id: "n-10", title: "《镜中列车》确认推出导演剪辑版，增加 12 分钟镜面段落", date: "2024-10-01", resourceId: "m-06", category: "movie", kind: "版本说明" },
];

export const topics: Topic[] = [
  {
    id: "t-01",
    title: "秋日科幻特辑",
    subtitle: "冷色调里的未来想象",
    description: "从深海到沙丘，六部把科学与孤独拍到极致的作品合集。",
    category: "movie",
    tag: "科幻",
    icon: "ri-planet-line",
  },
  {
    id: "t-02",
    title: "国漫新浪潮",
    subtitle: "水墨与机械的碰撞",
    description: "近年最值得关注的国产动画，从江湖到云端的世界观搭建。",
    category: "anime",
    tag: "奇幻",
    icon: "ri-brush-line",
  },
  {
    id: "t-03",
    title: "深夜音乐电台",
    subtitle: "适合一个人听完",
    description: "氛围、后摇与城市流行，整理出一份完整的夜间收听清单。",
    category: "music",
    tag: "氛围",
    icon: "ri-headphone-line",
  },
];

export const heroSlides: string[] = ["a-01", "m-01", "mu-02", "a-03"];